export default "__VITE_ASSET__BLyhzFDx__"